<script lang="ts" setup>
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { ChevronRight } from 'lucide-vue-next';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <li
        data-slot="breadcrumb-separator"
        role="presentation"
        aria-hidden="true"
        :class="cn('text-border [&>svg]:size-3.5', props.class)"
    >
        <slot>
            <ChevronRight />
        </slot>
    </li>
</template>
